import React, { useEffect } from 'react'

import { publishEvent } from '@zet/analytics'

import { MagnetStrip } from './magnetStrip'
import { OtherBrandsStrip } from './otherBrandsStrip'

type MagnetCrossSellingStripProps = {
  isMagnetEligible?: boolean
  partnerName?: string
  customerName?: string
}

const MagnetCrossSellingStrip = ({
  isMagnetEligible,
  partnerName,
  customerName,
}: MagnetCrossSellingStripProps) => {
  useEffect(() => {
    publishEvent('widget_view', {
      widget_name: isMagnetEligible
        ? 'magent_cross_selling_strip'
        : 'other_brands_cross_selling_strip',
    })
  }, [])

  if (isMagnetEligible) {
    return <MagnetStrip customerName={customerName} />
  }
  return (
    <OtherBrandsStrip partnerName={partnerName} customerName={customerName} />
  )
}

export { MagnetCrossSellingStrip }
